import React from "react";

import { TouchableOpacity, ViewStyle } from "react-native";
import { SvgProps } from "react-native-svg";
import AppTheme from "../../utils/Theme";
import SVGView from "../../utils/SvgView";

interface NavBarButtonProps {
    icon: React.FC<SvgProps>;
    action: () => void;
    color?: string;
    style?: ViewStyle;
}

const NavBarButton = (props: NavBarButtonProps) => {

    const appTheme: AppTheme = new AppTheme();

    const { icon, action, color = appTheme.darkBlue, style } = props;
    let navBarButtonStyle: ViewStyle[] = [{ backgroundColor: appTheme.white, width: appTheme.pixelPerfect(30), height: appTheme.pixelPerfect(30), borderRadius: appTheme.pixelPerfect(15), justifyContent: "center", alignItems: "center" }];
    if (style !== undefined) {
        navBarButtonStyle.push(style);
    }
    return <TouchableOpacity onPress={action} style={navBarButtonStyle}>
        <SVGView Component={icon} size={appTheme.pixelPerfect(14)} color={color} />
    </TouchableOpacity>
}

export default NavBarButton;